module.exports = "//__CDN_HOST__/2.0.8/img/More-4.5f345f1c.png";